var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeaderTab',{attrs:{"title":_vm.$t('mediatheque.title'),"swiper_tabs":_vm.swiper_tabs}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }